import React, { useState, useEffect, useRef, useCallback } from "react";
import NotificationAlert from "react-notification-alert";

import { DefaultInput } from "ui-kit-takeat";

import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  Button,
} from "reactstrap";

import { Form } from "@unform/web";
// import Input from "./Input";

import { LinkStyled } from "views/pages/styles";
import { useRestaurants } from "context/RestaurantsContext";

import CardMultistore from "./CardMultistore";

import apiGd from "../../../services/apiGd";

function Multistores() {
  const notificationAlert = useRef(null);
  const { multistores: contextMultistores, getMultistores } = useRestaurants();

  const [multistores, setMultistores] = useState(contextMultistores);
  const [search, setSearch] = useState('');
  const [id, setId] = useState(0);

  useEffect(() => {
    if (contextMultistores?.length === 0) {
      getMultistores();
    }
  }, [contextMultistores, getMultistores]);

  useEffect(() => {
    const filtered =
      search
        ? contextMultistores.filter(
          (restaurant) =>
            (
              restaurant.fantasy_name.toLowerCase().includes(search) ||
              restaurant.name.includes(search)
            )
        )
        : contextMultistores;

    filtered.sort((a, b) => a.id - b.id);

    setMultistores(filtered);
  }, [contextMultistores, multistores, search]);

  const notify = (place, color, message) => {
    var options = {};
    options = {
      place: place,
      message: (
        <div>
          <div>{message}</div>
        </div>
      ),
      type: color,
      icon: 'now-ui-icons ui-1_bell-53',
      autoDismiss: 7,
    };
    notificationAlert.current.notificationAlert(options);
  };

  const onRecover = useCallback(async (restaurant_id) => {
  }, [multistores]);

  return (
    <>
      <NotificationAlert ref={notificationAlert} zIndex={10009999}/>

      <div className="content" style={{marginLeft: '50px', marginRight: '50px'}}>
        <Row md="12" style={{ marginBottom: "10px" }}>
          <Col md="8">
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={{ fontSize: '2em', marginRight: '5px' }}>Multilojas</div>
              <LinkStyled to={"/multistores/new"}>
                <Button className="btn-round" style={{ margin: 0 }} color="success" outline>
                  <i className="fa fa-plus" />
                  Novo
                </Button>
              </LinkStyled>
            </div>
          </Col>

          <Col md="4">
            <Form>
              <DefaultInput
                name="search"
                placeholder="Pesquisar"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </Form>
          </Col>
        </Row>

        {multistores.length !== 0 ? (
          <Row>
            {multistores.map((multistore, i) => (
              <Col md="4" key={i}>
                <CardMultistore multistore={multistore} />
              </Col>
            ))}
          </Row>
        ) : (
          <h4 style={{margin: '20px', width: 'fit-content'}}>
            Nenhum restaurante nessa categoria
          </h4>
        )}
      </div>
    </>
  );
}

export default Multistores;

